(ns client-portal.client.voice-insights.restaurant-insight.views
  (:require [client-portal.client.anonymous.data :as anon.d]
            [client-portal.client.day-part-schedules.data :as dp]
            [shared.core.components.components :as c]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.voice-insights.shared :as vi.shared]
            [client-portal.client.locations.data :as locations.d]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [shared.core.time :as t]
            [shared.core.util :as util]))

(defn location-header-loading []
  [:div {:style {:display :flex
                 :flex-direction :column
                 :gap 14
                 :width "100%"
                 :padding 16}}
   [:div {:style {:display :flex
                  :gap 24}}
    [:div {:style {:width 105
                   :height 105
                   :border-radius 5
                   :overflow :hidden
                   :position :relative}}
     [c/loader-rectangle {:width 105 :height 105}]]
    [:div {:style {:display :flex
                   :flex-direction :column
                   :flex 1
                   :gap 8}}
     [c/loader-rectangle {:width 380
                          :height 14
                          :style {:margin-bottom 8}}]
     [c/loader-rectangle {:width 240
                          :height 14}]]]
   [vi.shared/header-analytics {:conversations-count :loading
                                :conversations-duration :loading
                                :conversations-duration-over-time :loading
                                :crew-utterances-count :loading
                                :customer-utterances-count :loading
                                :crew-utterances-count-over-time :loading
                                :customer-utterances-count-over-time :loading
                                :style {:margin-top 0}}]])

(defn location-header
  []
  (let [conversations-count- (re/subscribe [:voice-insights/conversations-count-])
        conversations-duration- (re/subscribe [:voice-insights/conversations-avg-duration-])
        conversations-duration-over-time- (re/subscribe [:voice-insights/conversations-avg-duration-over-time-])
        crew-utterances-count- (re/subscribe [:voice-insights/crew-conversations-utterance-count-])
        customer-utterances-count- (re/subscribe [:voice-insights/user-conversations-utterance-count-])
        crew-utterances-count-over-time- (re/subscribe [:voice-insights/crew-conversations-utterance-count-over-time-])
        customer-utterances-count-over-time- (re/subscribe [:voice-insights/user-conversations-utterance-count-over-time-])
        location-details- (re/subscribe [:locations/by-current-location-id-])
        location-details (if (util/loading? @location-details-)
                           :loading
                           @location-details-)
        location-loading? (util/loading? location-details)
        location-open? (and location-details (not= location-details :loading) (:open? location-details))
        occasions (if (util/not-loading? location-details) (:occasions location-details) [])
        today-occasion (when (not-empty occasions)
                         (some->> (locations.d/find-today-occasions {:occasions occasions
                                                                     :timezone (:timezone location-details)})
                                  (filter (comp pos? :time-to-close))
                                  (sort-by :time-to-close)
                                  (last)))]
    [:div {:style {:display :flex
                   :flex-direction :column
                   :gap 14
                   :width "100%"
                   :padding 16}}
     [:div {:style {:display :flex
                    :gap 24}}
      (when (or location-loading?
                (and (not-empty (str (:latitude location-details)))
                     (not-empty (str (:longitude location-details)))))
        (let [map-size 95]
          [:div {:style (cond-> {:width map-size
                                 :height map-size
                                 :border-radius 5
                                 :overflow :hidden
                                 :position :relative}
                                (not location-loading?)
                                (assoc :cursor :pointer))
                 :on-click (when-not location-loading?
                             #(re/dispatch-sync [:router/go-open-new-url
                                                 (str "https://maps.google.com/?q="
                                                      (:latitude location-details)
                                                      ","
                                                      (:longitude location-details))]))}
           (if location-loading?
             [c/loader-rectangle {:width map-size :height map-size}]
             [:div {:style {:width (+ 400 map-size)
                            :height (+ 400 map-size)
                            :position :absolute
                            :top -200
                            :left -200
                            :transform "scale(0.5)"}}
              [c/google-map-iframe {:latitude (:latitude location-details)
                                    :longitude (:longitude location-details)
                                    :zoom 13
                                    :style {:pointer-events :none}}]])]))
      [:div {:style {:display :flex
                     :flex-direction :column
                     :flex 1
                     :gap 8}}
       (if location-loading?
         [c/loader-rectangle {:width 380
                              :height 14
                              :style {:margin-bottom 8}}]
         [:div {:style {:padding-bottom 4
                        :font-family style/roboto-font-family
                        :font-size 15
                        :font-weight style/font-semi-bold-weight
                        :color (style/alc-color "Text/primary_header")}}
          (anon.d/location-label (:label location-details))])
       (if location-loading?
         [c/loader-rectangle {:width 240
                              :height 14}]
         [:<>
          (when (not-empty (:street-address location-details))
            [:div {:style {:display :flex
                           :align-items :center
                           :gap 8}}
             [c/material-icon {:icon-type :location-on
                               :style {:font-size 16
                                       :color (style/alc-color "Icons/primary")}}]
             [:div {:style {:font-family style/roboto-font-family
                            :font-size 12
                            :font-weight style/font-regular-weight
                            :line-height :normal
                            :color (style/alc-color "Text/primary")}}
              (util/->formatted-address {:street-address-1 (:street-address location-details)
                                         :city (:city location-details)
                                         :state (:state-code location-details)
                                         :country (:country-code location-details)})]])
          ;; TODO: Fix this - it doesn't work well
          #_[:div {:style {:display :flex
                           :align-items :center
                           :gap 8}}
             [c/material-icon {:icon-type :watch-later
                               :style {:font-size 16
                                       :color (style/alc-color "Icons/primary")}}]
             [:div {:style {:font-family style/roboto-font-family
                            :font-size 12
                            :font-weight style/font-regular-weight
                            :line-height :normal
                            :color (style/alc-color "Text/primary")}}
              (str (:day-of-week today-occasion) " "
                   (locations.d/format-am-pm (:opens-at today-occasion) (:timezone location-details)) "-"
                   (locations.d/format-am-pm (:closes-at today-occasion) (:timezone location-details))
                   (when location-open?
                     (let [hours (t/seconds->hours (:time-to-close today-occasion))]
                       (str " (Closes in " hours " " (util/pluralize "hour" hours) ")"))))]
             [:div {:style {:font-family style/roboto-font-family
                            :font-size 12
                            :font-weight style/font-regular-weight
                            :line-height :normal
                            :color (if location-open? (style/color :green :shade-8) (style/color :red :shade-6))}}
              (if location-open? "Open" "Closed")]]
          (when (not-empty (:telephone location-details))
            [:div {:style {:display :flex
                           :align-items :center
                           :gap 8}}
             [c/material-icon {:icon-type :call
                               :style {:font-size 16
                                       :color (style/alc-color "Icons/primary")}}]
             [:div {:style {:font-family style/roboto-font-family
                            :font-size 12
                            :font-weight style/font-regular-weight
                            :line-height :normal
                            :color (style/alc-color "Text/primary")}}
              (util/readable-phone-number (:telephone location-details))]])])]]
     [vi.shared/header-analytics {:conversations-count @conversations-count-
                                  :conversations-duration @conversations-duration-
                                  :conversations-duration-over-time @conversations-duration-over-time-
                                  :crew-utterances-count @crew-utterances-count-
                                  :customer-utterances-count @customer-utterances-count-
                                  :crew-utterances-count-over-time @crew-utterances-count-over-time-
                                  :customer-utterances-count-over-time @customer-utterances-count-over-time-
                                  :style {:margin-top 0}}]]))

(defn frequent-tag-button
  [{:keys [label value color]}]
  (let [selected-frequent-tag- (re/subscribe [:vi-restaurant-insight/frequent-tag-])
        selected? (= value @selected-frequent-tag-)]
    [c/interactive
     :div {:style {:display :flex
                   :align-items :center
                   :gap 8
                   :padding "3px 12px 3px 9px"
                   :border "1px solid rgba(0, 0, 0, 0.2)"
                   :border-radius 60
                   :background-color (if selected?
                                       "rgba(153, 51, 240, 0.20)"
                                       (style/color :white :base))}
           :hover-style {:background-color (if selected?
                                             "rgba(153, 51, 240, 0.20)"
                                             (util/hex->rgba (style/color :black :base) 0.02))
                         :cursor :pointer}
           :on-click #(re/dispatch [:vi-restaurant-insight/select-frequent-tag value])}
     (when color
       [c/material-icon {:icon-type :fiber-manual-record
                         :style {:font-size 12
                                 :color color}}])
     [:span {:style {:font-family style/roboto-font-family
                     :font-size 12
                     :line-height "18px"
                     :font-weight style/font-regular-weight
                     :color (style/color :black :base)}}
      label]]))

(defn location-analytics
  []
  (let [categories [{:category "marketing" :sort-order 1}
                    {:category "efficiency" :sort-order 2}
                    {:category "satisfaction" :sort-order 3}]
        conversations-count @(re/subscribe [:voice-insights/conversations-count-])
        scores-by-category @(re/subscribe [:voice-insights/scores-by-category-])
        concept-scores-by-category @(re/subscribe [:voice-insights/concept-scores-by-category-])
        scores-by-category-over-time @(re/subscribe [:voice-insights/scores-by-category-over-time-])
        ces-scores? @(re/subscribe [:voice-insights/ces-feature-enabled?-])
        ces-score (when ces-scores? @(re/subscribe [:voice-insights/ces-score-]))
        concept-ces-score (when ces-scores? @(re/subscribe [:voice-insights/concept-ces-score-]))
        ces-score-over-time (when ces-scores? @(re/subscribe [:voice-insights/ces-score-over-time-]))
        conversation-tags-count @(re/subscribe [:voice-insights/conversation-tags-count-])
        day-parts-schedules @(re/subscribe [:day-parts/by-current-concept-id-])
        selected-day-part @(re/subscribe [:voice-insights/selected-day-part-])
        location-id @(re/subscribe [:locations/current-selected-location-id-])
        satisfaction-name- (re/subscribe [:voice-insights/satisfaction-name-])
        day-part-schedules (when-not (util/loading? day-parts-schedules)
                             (or (not-empty (dp/location-day-parts day-parts-schedules location-id))
                                 (dp/concept-day-parts day-parts-schedules)))
        has-data? (not= conversations-count 0)]
    [:div {:style {:width "100%"
                   :height "100%"
                   :padding "28px 16px"
                   :flex 1
                   :display :flex
                   :flex-direction :column
                   :gap 16}}
     [c/h1 {:style {:font-size 18
                    :font-family style/roboto-font-family
                    :font-weight 700
                    :line-height "24px"
                    :color (style/alc-color "Text/primary_header")}}
      "Insight Scores"]
     (when (not-empty day-part-schedules)
       [vi.shared/day-parts-radio-buttons {:day-parts (or (not-empty (dp/location-day-parts day-parts-schedules
                                                                                            location-id))
                                                          (dp/concept-day-parts day-parts-schedules))
                                           :selected-day-part selected-day-part
                                           :on-change #(do
                                                         (re/dispatch [:router/go-with-merged-query-params
                                                                       {:dp (:label %)}])
                                                         (re/dispatch [:voice-insights/select-day-part (:label %)]))}])
     (if has-data?
       (into [:div {:class-name style/stack-on-mobile-class-name
                    :style {:display :flex
                            :gap 8
                            :margin-bottom 8}}]
             (->> (sort-by :sort-order categories)
                  (map (fn [{:keys [category]}]
                         (let [data-loading? #(or (util/loading? %) (nil? %))
                               show-ces-score? (and ces-scores? (= category "marketing"))
                               score (if (data-loading? scores-by-category)
                                       :loading
                                       (some->> (vi.d/matches-category category scores-by-category)
                                                (first)
                                                :score))
                               avg-score (if (data-loading? concept-scores-by-category)
                                           :loading
                                           (some->> (vi.d/matches-category category concept-scores-by-category)
                                                    (first)
                                                    :score))
                               scores-over-time (if (data-loading? scores-by-category-over-time)
                                                  :loading
                                                  (vi.d/matches-category category scores-by-category-over-time))]
                           [vi.shared/concept-category-scores (cond-> {:category category
                                                                       :score (if show-ces-score?
                                                                                ces-score
                                                                                score)
                                                                       :avg-score (if show-ces-score?
                                                                                    concept-ces-score
                                                                                    avg-score)
                                                                       :scores-over-time (if show-ces-score?
                                                                                           ces-score-over-time
                                                                                           scores-over-time)}

                                                                      show-ces-score?
                                                                      (assoc :category-label "CES"
                                                                             :gauge-config {;:colors ["#4AC53F" "#FEAC2A" "#FF8080"]
                                                                                            :stops [4 2 1]})

                                                                      (= category "marketing")
                                                                      (-> (assoc :icon-type :shopping-bag)
                                                                          (assoc :color "#69AEFF")
                                                                          (assoc :bg-color "#C3F3FF"))

                                                                      (= category "efficiency")
                                                                      (-> (assoc :icon-type :timer)
                                                                          (assoc :color "#7247FF")
                                                                          (assoc :bg-color "#D9DDFE"))

                                                                      (= category "satisfaction")
                                                                      (-> (assoc :category-label @satisfaction-name-)
                                                                          (assoc :icon-type :emoji-emotions)
                                                                          (assoc :color "#19E39A")
                                                                          (assoc :bg-color "#BDFFEF")))])))))
       [empty-state/no-data-card])
     (when has-data?
       [vi.shared/key-metrics conversation-tags-count {}])]))

(defn dashboard-container [& contents]
  (into [:div {:style {:display :flex
                       :flex-direction :column
                       :width "100%"
                       :min-height "100%"}}]
        contents))

(defn dashboard-loading []
  [dashboard-container
   [location-header-loading]])

(defn loaded-dashboard [args]
  [dashboard-container
   [location-header args]
   [location-analytics args]])

(defn dashboard [_]
  (let [day-parts- (re/subscribe [:day-parts/by-current-concept-id-])
        tags- (re/subscribe [:vi-tags/list-by-current-concept-id-])]
    (fn [args]
      (if (or (util/loading? @day-parts-) (util/loading? @tags-))
        [dashboard-loading]
        [loaded-dashboard args]))))
